import { inject, injectable } from "inversify";
import {
  ClientAccountEmailModel,
  ClientAddressModel,
  ClientContactDetailsModel,
  ICPLClientPortalAccountContactDetailsClient,
  NewClientAddressModel,
  NewClientEmailModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalAccountContactDetailsService {
  getClientContactDetails(): Promise<ClientContactDetailsModel[]>;
  getClientAddressDetails(clientId: string): Promise<ClientAddressModel[]>;
  getClientEmailAddressDetails(clientId: string): Promise<ClientAccountEmailModel[]>;
  updateClientAddress(clientAddressModel: ClientAddressModel): Promise<void>;
  updateClientEmailAddress(clientAccountEmailModel: ClientAccountEmailModel): Promise<void>;
  deleteClientEmailAddress(clientAccountEmailID: string): Promise<void>;
  deleteClientAddress(clientEmailID: string): Promise<void>;
  createClientEmail(newAddress: NewClientEmailModel): Promise<void>;
  createClientAddress(newAddress: NewClientAddressModel): Promise<void>;
}

@injectable()
export class ClientPortalAccountContactDetailsService implements IClientPortalAccountContactDetailsService {
  @inject(SERVICE_TYPES.CPLClientPortalAccountContactDetailsClient)
  cplClientPortalAccountContactDetailsClient!: ICPLClientPortalAccountContactDetailsClient;

  async getClientContactDetails(): Promise<ClientContactDetailsModel[]> {
    return await this.cplClientPortalAccountContactDetailsClient.getClientContactDetails();
  }

  async getClientAddressDetails(clientID: string): Promise<ClientAddressModel[]> {
    return await this.cplClientPortalAccountContactDetailsClient.getClientAddressDetails(clientID);
  }

  async getClientEmailAddressDetails(clientID: string): Promise<ClientAccountEmailModel[]> {
    return await this.cplClientPortalAccountContactDetailsClient.getClientEmailAddressDetails(clientID);
  }

  async updateClientAddress(clientAddressModel: ClientAddressModel): Promise<void> {
    return await this.cplClientPortalAccountContactDetailsClient.updateClientAddress(clientAddressModel);
  }

  async updateClientEmailAddress(clientAccountEmailModel: ClientAccountEmailModel): Promise<void> {
    return await this.cplClientPortalAccountContactDetailsClient.updateClientEmailAddress(clientAccountEmailModel);
  }

  async deleteClientEmailAddress(clientAccountEmailID: string): Promise<void> {
    return await this.cplClientPortalAccountContactDetailsClient.deleteClientEmailAddress(clientAccountEmailID);
  }

  async deleteClientAddress(clientEmailID: string): Promise<void> {
    return await this.cplClientPortalAccountContactDetailsClient.deleteClientAddress(clientEmailID);
  }

  async createClientEmail(newAddress: NewClientEmailModel): Promise<void> {
    return await this.cplClientPortalAccountContactDetailsClient.createClientEmailAddress(newAddress);
  }

  async createClientAddress(newAddress: NewClientAddressModel): Promise<void> {
    return await this.cplClientPortalAccountContactDetailsClient.createClientAddress(newAddress);
  }
}
